<ng-template #pageContent>
  <rask-container-block>
    <ng-container headerContent>
      <rask-mina-handelssortiment-list [class]="{scroll30: !isModalActive, scroll20: isModalActive}"
        (minaHandelssortimentList)="onMinaHandelssortimentList($event)"
        (handelssortimentModifications)="onHandelssortimentModifications($event)"
      [addedHandelssortiment]="currentHandelssortiment"></rask-mina-handelssortiment-list>
    </ng-container>
  </rask-container-block>

  <rask-container-block>
    <ng-container>
      <rask-mina-handelssortiment-search-panel
      (handelssortimentListaUtsokta)="onSearch($event)"></rask-mina-handelssortiment-search-panel>

      <rask-mina-handelssortiment-result [class]="{scroll30: !isModalActive, scroll20: isModalActive}"
        (addHandelssortiment)="onAddHandelssortiment($event)"
        [minaHandelssortimentList]="minaHandelssortimentList"
      [handelssortimentListaUtsokta]="handelssortimentListaUtsokta"></rask-mina-handelssortiment-result>
    </ng-container>
  </rask-container-block>
</ng-template>

@if (!isModalActive) {
  <rask-page
    [pageTitle]="texts.minaHandelssortiment">
    <ng-container [ngTemplateOutlet]="pageContent"></ng-container>
    <ng-container footerContent>
      <rask-button
        aid="buttonSpara"
        class="me-3"
        color="primary"
        [disabled]="!canSave()"
        (click)="saveMinaHandelssortimentFavoriter()"
        placement="left"
        raskHotkey="ctrl+s"
        [ngbTooltip]="texts.hotkeysSave">
        <span>{{ texts.save }}</span>
      </rask-button>
    </ng-container>
  </rask-page>
}

@if (isModalActive) {
  <div class="modal-header">
    <h3 class="modal-title">{{texts.minaHandelssortiment}}</h3>
  </div>
  <ng-container [ngTemplateOutlet]="pageContent"></ng-container>
  <div class="modal-footer">
    <rask-button
      aid="buttonSpara"
      class="me-3"
      color="primary"
      [disabled]="!canSave()"
      (click)="saveMinaHandelssortimentFavoriter()"
      placement="left"
      raskHotkey="ctrl+s"
      [ngbTooltip]="texts.hotkeysSave">
      <span>{{ texts.save }}</span>
    </rask-button>
    <rask-button color="secondary" (click)="onClose()">
      {{ texts.close }}
    </rask-button>
  </div>
}